// @flow
export default {
  app: {
    name: 'FUNDOOR',
    isMufg: false,
    railsEnv: 'production'
  },
  validations: {
    maxFileSize: '10485760'
  },
  helpUrl: 'https://help.fundoor.com/ja/',
  google: {
    universalAnlytics: {
      userID: 'UA-72221753-9'
    }
  },
  documents: {
    maxFileSize: 62914560
  },
  irs: {
    maxFileSize: 52428800,
    maxFileNumber: 10,
    maxContentLength: 65535,
    defaultExtension: ["png", "jpg", "jpeg", "gif", "pdf", "xls", "xlsx", "doc", "docx", "ppt", "pptx"],
    defaultExtensionForHTML: [".png", ".jpg", ".jpeg", ".gif", ".pdf", ".xls", ".xlsx", ".doc", ".docx", ".ppt", ".pptx"]
  },
  officerApprovals: {
    maxFileSize: 31457280,
    maxMinuteFileSize: 20971520,
    defaultExtension: ["png", "jpg", "jpeg", "pdf", "xls", "xlsx", "doc", "docx"],
    resolutionReport: {
      maxFileSize: 62914560
    }
  },
  importantMeetings: {
    maxFileSize: 31457280,
    defaultExtension: ["png", "jpg", "jpeg", "pdf", "xls", "xlsx", "doc", "docx"],
  },
  bizReports: {
    maxFileSize: 60000000,
    limitWordNumber: 20000,
    defaultExtension: ["image/png", "image/jpeg", "image/gif"]
  },
  matchings: {
    maxFileSize: 5242880,
    defaultExtension: ["png", "jpg", "jpeg"]
  },
  pitches: {
    maxFileSize: 10485760,
    defaultExtension: ["pdf"]
  },
  companySettings: {
    maxFileSize: 5242880,
    defaultExtension: ["png", "jpg", "jpeg"]
  },
  contractFiles: {
    maxFileSize: 20971520
  },
  ir_requests: {
    maxTitleLength: 255,
    maxContentLength: 300,
    maxFileSize: 52428800,
    maxFileNumber: 10,
    defaultExtension: ["png", "jpg", "jpeg", "gif", "pdf", "xls", "xlsx", "doc", "docx", "ppt", "pptx"],
    defaultExtensionForHTML: [".png", ".jpg", ".jpeg", ".gif", ".pdf", ".xls", ".xlsx", ".doc", ".docx", ".ppt", ".pptx"]
  }
}
